var subProArray = [];
var isEdit = false;
var bundleId = null;
var GWP_LIMIT = 1;

document.addEventListener("DOMContentLoaded", function () {
  window.onbeforeunload = function (e) {
    const message = "Are you sure you want to leave this page?";
    e.preventDefault();
    e.returnValue = message;
    return message;
  };
});

let moveGWPItemToLast = (items = []) => {
  const gwpIndex = items.findIndex((obj) => obj.isGWP);
  if (gwpIndex !== -1) {
    const gwpItem = items[gwpIndex];
    items.splice(gwpIndex, 1);
    items.push(gwpItem);
  }
  return items;
};

let getFilteredLength = (array, filterFunc) => {
  return array.filter(filterFunc)?.length || 0;
};

let showAlert = (message = "", isDefault = false) => {
  try {
    let element = document.querySelector("[data-warn-popup2]");
    element.classList.remove("hidden");
    if (!isDefault) {
      let alertMessage = element.querySelector(".warning-content p");
      alertMessage.innerHTML = message;
    }
  } catch (error) {
    console.error("An error occurred while showing the alert:", error);
  }
};

function clearPaletteProduct(index) {
  document
    .querySelector("[data-subimg-" + index + "]")
    .style.removeProperty("background-image");
  document
    .querySelector("[data-subimg-" + index + "]")
    .style.removeProperty("background-color");
  document.querySelector("[data-subtitle-" + index + "]").innerHTML = "";
  document.querySelector("[data-subdesc-" + index + "]").innerHTML = "";
  document
    .querySelector('[data-sub-remove="' + index + '"]')
    .classList.add("hidden");
  document
    .querySelector("[data-border-" + index + "]")
    .classList.add("card-palette-dot");
  document
    .querySelector("[data-border-" + index + "]")
    .classList.remove("card-palette");
}

let setSubProArray = (items) => {
  const bundleLimit = Number(
    document.querySelector(".palette-bundle").getAttribute("data-bun-limit")
  );
  const updateBox = (index, val) => {
    const subImgElement = document.querySelector(`[data-subimg-${index}]`);
    const subDescElement = document.querySelector(`[data-subdesc-${index}]`);
    const subTitleElement = document.querySelector(`[data-subtitle-${index}]`);
    const subRemoveElement = document.querySelector(
      `[data-sub-remove="${index}"]`
    );
    const borderElement = document.querySelector(`[data-border-${index}]`);

    if (val.varcolor == undefined) {
      subImgElement.style.cssText = `
            background-image:url('${val.varimg}'); 
            background-repeat: no-repeat;
            `;
    } else if (val.varimg == undefined) {
      subImgElement.setAttribute("style", "background-color:" + val.varcolor);
    }

    if (val.vardesc != undefined) {
      subDescElement.innerHTML = val.vardesc;
    }

    subTitleElement.innerHTML = val.varTitle;
    subRemoveElement.classList.remove("hidden");
    borderElement.classList.remove("card-palette-dot");
    borderElement.classList.add("card-palette");
  };

  if (items.length > 0) {
    items.forEach((val, index) => {
      const currentIndex = val.isGWP ? bundleLimit : index + 1;
      updateBox(currentIndex, val);
    });
    // window.onbeforeunload = function (e) {
    //   let message =
    //     "If you exit the page now you will lose your product selections. Are you sure you want to leave this page?";
    //   return message;
    // };
  }
};

class bundleElement extends HTMLElement {
  constructor() {
    super();

    document
      .querySelectorAll("[data-bundle-add]")
      .forEach((button) =>
        button.addEventListener("click", this.addProductList.bind(this))
      );
    document
      .querySelectorAll(".card-close")
      .forEach((button) =>
        button.addEventListener("click", this.removeProductList.bind(this))
      );
    document
      .querySelectorAll(".bundle-atc")
      .forEach((button) =>
        button.addEventListener("click", this.bundleATC.bind(this))
      );
    // var bundleLimit = Number(document.querySelector('.palette-bundle').getAttribute('data-bun-limit'));
    var getURL = window.location.href.split("/").pop();
    var lastPart = getURL.split("?edit=");
    console.log("eree", lastPart[1]);
    if (lastPart[1] != undefined) {
      bundleId = lastPart[1];
      this.editBundle(bundleId);
      isEdit = true;
    }
  }

  updateEvent() {
    document
      .querySelectorAll("[data-bundle-add-quick]")
      .forEach((button) =>
        button.addEventListener("click", this.addProductList.bind(this))
      );
  }

  addProductList(event) {
    let varName = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varName");
    let varSku = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varSku");
    let varId = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("value");
    let varTitle = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varTitle");
    let varPrice = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varPrice");
    let varDesc = event.currentTarget
      .closest("form")
      .querySelector("[data-productid]")
      .getAttribute("varDesc");
    let varCategoryName = document
      .querySelector("input[data-category-name]")
      ?.getAttribute("data-category-name");
    let varIsGWP =
      document
        .querySelector("input[data-is-bundle-gwp]")
        ?.getAttribute("data-is-bundle-gwp") === "true";
    let bundleContainsGWP =
      document
        .querySelector("input[data-is-contain-gwp]")
        ?.getAttribute("data-is-contain-gwp") === "true";

    let varColorName = "";
    let featureImg = "";
    let varColor = "";

    let bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit")
    );
    let currentCategoryLimit = Number(
      document
        .querySelector("input[data-category-limit]")
        ?.getAttribute("data-category-limit")
    );
    let isVariantBundle =
      event.target.closest("button").getAttribute("data-variant-bundle") ==
      "true";
    let singleVariant = null;

    if (isVariantBundle) {
      singleVariant = true;
      varColorName = event.currentTarget
        .closest("form")
        .querySelector("[data-productid]")
        .getAttribute("varShade");
      featureImg = event.currentTarget
        .closest("form")
        .querySelector("[data-productid]")
        .getAttribute("varFeatureImg");
    } else if (
      event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked') == null ||
      event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked') == undefined
    ) {
      featureImg = event.currentTarget
        .closest("form")
        .querySelector("[data-productid]")
        .getAttribute("varFeatureImg");
      singleVariant = true;
    } else {
      singleVariant = false;
      varColor = event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked')
        .getAttribute("data-color");
      varColorName = event.currentTarget
        .closest(".product-card-wrapper")
        .querySelector('input[name="Color"]:checked')
        .getAttribute("value");
    }

    document.querySelector(".palette-bundle").classList.remove("hidden");
    document.querySelector(".up-down-bundle-open").classList.add("hidden");

    if (subProArray.length >= bundleLimit) {
      showAlert("", true);
    } else {
      let commonCategoryLength = getFilteredLength(
        subProArray,
        (arr) => !arr.isGWP
      );
      let specialCategoryLength = getFilteredLength(
        subProArray,
        (arr) => arr.isGWP
      );
      let currentCategoryLength = getFilteredLength(
        subProArray,
        (arr) => arr.varcatname === varCategoryName
      );

      const productDetails = {
        varname: varName,
        varsku: varSku,
        varid: varId,
        varTitle: varTitle,
        varcatname: varCategoryName,
        isGWP: varIsGWP,
        varPrice: varPrice,
        quantity: 1,
      };
      const getMessage = (limit, isGWP = false) => {
        const productCount = limit === 1 ? "item" : "items";
        const categoryType = !isGWP ? "this category" : "common categories";
        return `You can add only ${limit} ${productCount} from ${categoryType}`;
      };

      let _bundleLimit = bundleContainsGWP ? bundleLimit - 1 : bundleLimit;
      if (varIsGWP && specialCategoryLength >= currentCategoryLimit) {
        showAlert(getMessage(currentCategoryLimit));
      } else if (!varIsGWP && commonCategoryLength >= _bundleLimit) {
        showAlert(getMessage(_bundleLimit, true));
      } else if (currentCategoryLength >= currentCategoryLimit) {
        showAlert(getMessage(currentCategoryLimit));
      } else {
        if (singleVariant) {
          productDetails["varimg"] = featureImg;
          if (isVariantBundle) {
            productDetails["vardesc"] = varColorName;
          }
        } else {
          productDetails["varcolor"] = varColor;
          productDetails["vardesc"] = varColorName;
        }
        subProArray.push(productDetails);
      }
    }

    document
      .querySelectorAll(".palette-product")
      .forEach(function (val, index) {
        index = index + 1;
        clearPaletteProduct(index);
      });

    // subProArray = moveGWPItemToLast(subProArray)
    setSubProArray(moveGWPItemToLast(subProArray));

    if (subProArray.length == bundleLimit) {
      document
        .querySelectorAll(".bundle-atc")
        .forEach((button) => button.classList.remove("disabled-atc-btn"));
    }
  }

  removeProductList(event) {
    const bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit")
    );
    const getIndex =
      Number(event.currentTarget.getAttribute("data-sub-remove")) - 1;
    const getGWPIndex = subProArray.findIndex((i) => i.isGWP);
    const spliceIndex =
      getIndex === bundleLimit - 1 && getGWPIndex !== -1
        ? getGWPIndex
        : getIndex;

    subProArray.splice(spliceIndex, 1);

    document
      .querySelectorAll(".palette-product")
      .forEach(function (val, index) {
        index = index + 1;
        clearPaletteProduct(index);
      });

    setSubProArray(subProArray);
    document
      .querySelectorAll(".bundle-atc")
      .forEach((button) => button.classList.add("disabled-atc-btn"));
  }

  bundleATC(event) {
    var varId = event.currentTarget.getAttribute("data-var-id");
    var varName = document
      .querySelector("[data-gift-title]")
      ?.getAttribute("data-gift-title");
    var varSku = document
      .querySelector("[data-gift-sku]")
      ?.getAttribute("data-gift-sku");
    var varGIftVId = document
      .querySelector("[data-gift-varId]")
      ?.getAttribute("data-gift-varId");
    var varGiftPrice = document
      .querySelector("[data-gift-varPrice]")
      ?.getAttribute("data-gift-varPrice");

    var bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit")
    );
    var finalArray = [];
    var Items = {};
    var randomNum = Math.floor(Math.random() * 1000000000000);

    if (subProArray.length < bundleLimit) {
      if (
        !document
          .querySelector(".required-product-desk")
          .classList.contains("hidden")
      ) {
        document.querySelector("[data-warn-popup]").classList.remove("hidden");
      } else {
        document
          .querySelector(".required-product-desk")
          .classList.remove("hidden");
        document
          .querySelector(".required-product-mob")
          .classList.remove("hidden");
      }
      return false;
    }

    Items["_variant_ids"] = [];
    Items["_variants"] = [];
    subProArray.forEach((x) => {
      const obj = finalArray.find((o) => Number(o.varid) === Number(x.varid));
      if (obj) {
        // console.log('obj.quantity',obj.quantity,'x.quantity',x.quantity)
        obj.quantity = obj.quantity + x.quantity;
      } else {
        x.quantity = 1;
        finalArray.push(x);
      }
    });
    if (varName != null && varSku != null && varGIftVId != null) {
      finalArray.push({
        varname: varName,
        varsku: varSku,
        quantity: 1,
        varid: varGIftVId,
        varPrice: isNaN(parseFloat(varGiftPrice))
          ? 0
          : parseFloat(varGiftPrice),
      });
    }

    finalArray.forEach(function (i, e) {
      Items[e + 1] = `\n${i.quantity} x ${i.varname} [${i.varsku}]`;
      for (var j = 0; j < i.quantity; j++) {
        Items["_variant_ids"].push(i.varid);
        Items["_variants"].push({
          id: i.varid,
          price: isNaN(parseFloat(i.varPrice)) ? 0 : parseFloat(i.varPrice),
        });
      }

      if (finalArray.length == e + 1) {
        if (isEdit == false) {
          Items["_bundleId"] = randomNum;
        } else {
          Items["_bundleId"] = bundleId;
        }
      }
    });

    window.PAPBundle = { ...Items };
    Items["_variant_ids"] = Items["_variant_ids"].join(",");
    Items["_variants"] = JSON.stringify(Items["_variants"]);
    if (isEdit == false) {
      localStorage.setItem(randomNum, JSON.stringify(subProArray));
    } else if (isEdit == true) {
      localStorage.setItem(bundleId, JSON.stringify(subProArray));
    }

    if (subProArray.length == bundleLimit) {
      window.onbeforeunload = null;
      if (isEdit == false) {
        var body = {
          id: parseInt(varId),
          quantity: 1,
          properties: Items,
        };

        const result = fetch("/cart/add.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(body),
        }).then((response) => {
          document
            .querySelector("[data-success-popup]")
            .classList.remove("hidden");
        });
      } else if (isEdit == true) {
        fetch("/cart.json", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }).then((data) => {
          let res = data.json();
          res.then((result) => {
            result.items.forEach(function (items, e) {
              if (
                items.properties["_bundleId"] != undefined &&
                items.properties["_bundleId"] == bundleId
              ) {
                var itemKey = items.key;
                var quantity = items.quantity;
                var body = {
                  id: itemKey,
                  quantity: quantity,
                  properties: Items,
                };

                fetch("/cart/change.js", {
                  body: JSON.stringify(body),
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "xmlhttprequest",
                  },
                  method: "POST",
                })
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (json) {
                    var getHandle = document
                      .querySelector("[data-collection-handle]")
                      .getAttribute("data-collection-handle");
                    var newURL = "/collections/" + getHandle;
                    window.history.pushState(
                      "object or string",
                      "Title",
                      newURL
                    );
                    document
                      .querySelector("[data-success-popup]")
                      .classList.remove("hidden");
                  })
                  .catch(function (err) {
                    console.error(err);
                  });
              }
            });
          });
        });
      }
    }
  }

  editBundle(getId) {
    var bundleLimit = Number(
      document.querySelector(".palette-bundle").getAttribute("data-bun-limit")
    );
    subProArray = JSON.parse(localStorage.getItem(getId));

    document
      .querySelectorAll(".palette-product")
      .forEach(function (val, index) {
        index = index + 1;
        clearPaletteProduct(index);
      });

    setSubProArray(moveGWPItemToLast(subProArray));

    if (subProArray.length == bundleLimit) {
      document
        .querySelectorAll(".bundle-atc")
        .forEach((button) => button.classList.remove("disabled-atc-btn"));
    }
    document.querySelector(".palette-bundle").classList.remove("hidden");
    document.querySelector(".up-down-bundle-open").classList.add("hidden");
  }
}
customElements.define("bundle-element", bundleElement);
